/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFormsWithVersions } from '../../models/system-forms-with-versions';

export interface ReadSystemFormsApiV2SystemFormsOrgFormIdGet$Params {
  formId: string;
  org: string;
  versionId?: (string | null);
}

export function readSystemFormsApiV2SystemFormsOrgFormIdGet(http: HttpClient, rootUrl: string, params: ReadSystemFormsApiV2SystemFormsOrgFormIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<(SystemFormsWithVersions | {
})>> {
  const rb = new RequestBuilder(rootUrl, readSystemFormsApiV2SystemFormsOrgFormIdGet.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('org', params.org, {});
    rb.query('versionId', params.versionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(SystemFormsWithVersions | {
      })>;
    })
  );
}

readSystemFormsApiV2SystemFormsOrgFormIdGet.PATH = '/api/v2/system-forms/{org}/{formId}';
